import { FormLabelProps } from '@chakra-ui/react';
import { FormLabel } from 'components/UI';

const ProductFieldTitle = (props: FormLabelProps) => (
  <FormLabel
    display="flex"
    pr={1.5}
    fontWeight="normal"
    color="base2FontColour.500"
    textTransform="uppercase"
    mb={1}
    {...props}
  />
);

export default ProductFieldTitle;
